import {createSelector} from 'reselect';

import type {
  PolicyContentType,
  PolicyContentWithDiffType,
} from 'app/policies/types';
import type {
  DetailPolicySerializedType,
  DetailPolicyVersionSerializedType,
} from 'sweet-types';

export const getContentFromPolicy = createSelector<
  | (DetailPolicySerializedType | null | undefined)
  | (DetailPolicyVersionSerializedType | null | undefined),
  PolicyContentType | null,
  | (DetailPolicySerializedType | null | undefined)
  | (DetailPolicyVersionSerializedType | null | undefined)
>(
  (policy) => policy,
  (policy) =>
    policy != null
      ? {
          url: policy.url,
          html_url: policy.html_url,
          name: policy.name,
          content: policy.content || '',
          files: policy.attachments.files,
          videos: policy.attachments.videos,
          embeds: policy.attachments.embeds ?? [],
        }
      : null
);

export const getPolicyDataFromContent = (
  editableContent: PolicyContentType
): Partial<DetailPolicySerializedType> => {
  return {
    name: editableContent.name,
    content: editableContent.content,
    attachments: {
      files: editableContent.files,
      videos: editableContent.videos,
      embeds: editableContent.embeds ?? [],
    },
  };
};
export function policyHasAnyContent(
  policyContent?:
    | Partial<PolicyContentWithDiffType>
    | Partial<PolicyContentType>
): boolean {
  if (policyContent == null) {
    return false;
  }
  const {content, files, videos, embeds} = policyContent;
  return (
    content !== '' ||
    (files ?? []).length > 0 ||
    (videos ?? []).length > 0 ||
    (embeds ?? []).length > 0
  );
}
